/*
This file was created by the script build.py 
*/



import {fillSearchObjectCollisionSystem} from "./collisionSystem";

import {fillSearchObjectAcceleratorParameters} from "./acceleratorParameters";

import {fillSearchObjectPhysicsTheme} from "./physicsTheme";

import {fillSearchObjectWorkingGroup} from "./workingGroup";

import {fillSearchObjectFinalStates} from "./finalStates";

import {fillSearchObjectFinalStatesSignature} from "./finalStatesSignature";

import {fillSearchObjectInterpretation} from "./interpretation";

import {fillSearchObjectSmAnalysisCharacteristics} from "./smAnalysisCharacteristics";

import {fillSearchObjectFurtherSearchCategorisation} from "./furtherSearchCategorisation";

import {fillSearchObjectFurtherCategorisationHeavyIon} from "./furtherCategorisationHeavyIon";

import {globalSearchObject} from "./searchObjects"
import {getAllFiltered} from "./filter"
import {allCheckboxesState} from "./checkboxState"
import {errorMessage} from "./app"
import {favicon} from "../assets/favicon.ico"
import {cms_logo} from"../assets/cms_logo.png"
import { isProd } from "./app"

var helperUI = {
    
    "categoryCollisionSystem" : [],
    
    "categoryAcceleratorParameters" : [],
    
    "categoryPhysicsTheme" : [],
    
    "categoryWorkingGroup" : [],
    
    "categoryFinalStates" : [],
    
    "categoryFinalStatesSignature" : [],
    
    "categoryInterpretation" : [],
    
    "categorySmAnalysisCharacteristics" : [],
    
    "categoryFurtherSearchCategorisation" : [],
    
    "categoryFurtherCategorisationHeavyIon" : [],
    
}

export function callAllCategories(){
    
    fillSearchObjectCollisionSystem()
    
    fillSearchObjectAcceleratorParameters()
    
    fillSearchObjectPhysicsTheme()
    
    fillSearchObjectWorkingGroup()
    
    fillSearchObjectFinalStates()
    
    fillSearchObjectFinalStatesSignature()
    
    fillSearchObjectInterpretation()
    
    fillSearchObjectSmAnalysisCharacteristics()
    
    fillSearchObjectFurtherSearchCategorisation()
    
    fillSearchObjectFurtherCategorisationHeavyIon()
    

}

// check for turn category off
export function buttonOnClick( data ) {
    const buttonId = data["buttonId"];
    var button = document.getElementById(buttonId);
    if(!isProd){
     console.log("buttons",button.parentNode.childNodes)
    }
    const buttons = button.parentNode.childNodes;
    const numberOfButtons = (buttons.length-1)/2
    var counter = 0;

    if(!isProd){
     console.log("categoryName",document.getElementById(buttonId)
      .parentNode.parentNode.parentNode.childNodes[1].childNodes[1].id)
    }
   
    const categoryName = document.getElementById(buttonId)
    .parentNode.parentNode.parentNode.childNodes[1].childNodes[1].id;

    for(var i = 3; i <= buttons.length-2; i= i+2){
        var but = buttons[i]
        var isSelected = but.classList.contains('selected',"text-light")
        if(isSelected){
            helperUI[categoryName].push(but.value)
        }   
    }
    
    var show = button.classList.contains('selected',"text-light")
    var checkbox = document.getElementById(categoryName);

    if(!show){
        button.classList.add('selected',"text-light");
        checkbox.checked = true;
        allCheckboxesState[categoryName].checked = checkbox.checked
        if(!isProd){
            console.log(allCheckboxesState[categoryName])
        }
        
        if(!helperUI[categoryName].includes(document.getElementById(buttonId).value)){
             helperUI[categoryName].push(document.getElementById(buttonId).value)
        }
    }
    if(show){
        button.classList.remove('selected',"text-light");
        helperUI[categoryName] = helperUI[categoryName]
        .filter(element => element !== document.getElementById(buttonId).value)
        if(helperUI[categoryName].length==0){
            checkbox.checked = false;
            allCheckboxesState[categoryName].checked = checkbox.checked
            if(!isProd){
                console.log(allCheckboxesState[categoryName])
            }
            
            
        } 
    }

    for(var i = 1; i <= buttons.length-2; i= i+2){
        var but = buttons[i]
        var isSelected = but.classList.contains('selected',"text-light")
        if(isSelected){
            counter = counter +1;
        }   
    }
    if(!isProd){
        console.log("if",counter, numberOfButtons)
    }
    if(counter < numberOfButtons && counter != 0){
        checkbox.indeterminate = true;
        allCheckboxesState[categoryName].checked = false;
        allCheckboxesState[categoryName].indeterminate = checkbox.indeterminate
        
    }
    if(counter == 0){
        checkbox.indeterminate = false; 
        allCheckboxesState[categoryName].indeterminate = checkbox.indeterminate
        
    }
    if(counter == numberOfButtons){
        
        checkbox.indeterminate = false;
        checkbox.checked = true;
        allCheckboxesState[categoryName].checked = checkbox.checked
        
    }

    helperUI[categoryName] = [];

    callAllCategories()
}

// Add CSS Class selected to all Buttons
export function checkAllButtons( data ){
    const checkbox = document.getElementById(data["checkboxId"]);
    var buttons = checkbox.parentNode.parentNode.childNodes[3].childNodes[3].childNodes
    for(var i = 1; i <= buttons.length-2; i= i+2){
        var show = buttons[i].classList.contains('selected',"text-light")
        if(!show && checkbox.checked){
            buttons[i].classList.add('selected',"text-light");
        }
        if(show && !checkbox.checked){
            buttons[i].classList.remove('selected',"text-light");
        }  
    }
}
//global paper-Button
document.getElementById("buttonGlobalPaper").onclick = function(){
    var buttonPaper = document.getElementById($(this).attr("id"))
    if(buttonPaper.classList.contains("selected","text-light")){
        buttonPaper.classList.remove("selected","text-light")
        globalSearchObject.globalPaper = false
      
    }
    else{
        buttonPaper.classList.add("selected","text-light")
        globalSearchObject.globalPaper = true
        
    }
    callAllCategories()
    
}

//global PAS-Button
document.getElementById("buttonGlobalPAS").onclick = function globalPasButton(){
    var buttonPAS = document.getElementById($(this).attr("id"))
    if(buttonPAS.classList.contains("selected","text-light")){
        buttonPAS.classList.remove("selected","text-light")
        globalSearchObject.globalPas = false
       
    }
    else{
        buttonPAS.classList.add("selected","text-light")
        globalSearchObject.globalPas = true
        
    }
    callAllCategories()
    errorMessage()
    
}


//global Any-Button
document.getElementById("buttonGlobalAny").onclick = function(){
    var buttonAny = document.getElementById("buttonGlobalAny")
    var buttonAll = document.getElementById("buttonGlobalAll")
    buttonAny.classList.add("chosen","text-light","no-click");
    buttonAll.classList.remove("chosen","text-light","no-click")
    globalSearchObject.globalAny = true;
    callAllCategories()
}

// global All-Button
document.getElementById("buttonGlobalAll").onclick = function(){
    var buttonAny = document.getElementById("buttonGlobalAny")
    var buttonAll = document.getElementById("buttonGlobalAll")
    buttonAll.classList.add("chosen","text-light","no-click");
    buttonAny.classList.remove("chosen","text-light","no-click")
    globalSearchObject.globalAny = false;
    callAllCategories()
}

// global clear all Button
document.getElementById("buttonClearAll").onclick = function(){
    clearAll($(this).attr("id"))
   
}


export const clearAll = function(id){
    var buttonClearAll = document.getElementById(id);
    for(var i = 15; i < buttonClearAll.parentNode.parentNode.childNodes.length-5; i= i+4){
        var checkboxId = buttonClearAll.parentNode.parentNode.childNodes[i].childNodes[1].childNodes[1].id
        var checkbox = document.getElementById(checkboxId)
        checkbox.checked = false;
        checkbox.indeterminate = false;
        allCheckboxesState[checkboxId].checked = false;
        allCheckboxesState[checkboxId].indeterminate = false;
        checkAllButtons({
              "checkboxId" : checkboxId 
        })
    }  
    callAllCategories()

}

